module.exports = __webpack_public_path__ + "static/media/img-heritage-area2-TerayamaCharcoalKiln.45379dcb.jpg";